import { BottomNav, type BottomNavItem, Icons, MobileShell } from "@jod/ui";
import { createFileRoute, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { type MessageKey, useT } from "../features/i18n/index.ts";
import { useSession } from "../features/session/session-context.tsx";

export const Route = createFileRoute("/_tabs")({
  component: TabsLayout,
});

type TabPath = "/home" | "/menu" | "/around" | "/gifts/incoming" | "/me";

const TABS: { key: string; labelKey: MessageKey; icon: ReactNode; to: TabPath }[] = [
  { key: "home", labelKey: "nav.home", icon: <Icons.IconHome />, to: "/home" },
  { key: "menu", labelKey: "nav.order", icon: <Icons.IconMenuGlyph />, to: "/menu" },
  { key: "around", labelKey: "nav.around", icon: <Icons.IconAround />, to: "/around" },
  { key: "gifts", labelKey: "nav.inbox", icon: <Icons.IconGiftNav />, to: "/gifts/incoming" },
  { key: "me", labelKey: "nav.me", icon: <Icons.IconMe />, to: "/me" },
];

function TabsLayout() {
  const t = useT();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { pendingInbox } = useSession();

  const items: BottomNavItem[] = TABS.map((tab) => ({
    key: tab.key,
    label: t(tab.labelKey),
    icon: tab.icon,
    active: pathname.startsWith(tab.to.replace("/incoming", "")),
    badge: tab.key === "gifts" && pendingInbox > 0 ? pendingInbox : undefined,
    onSelect: () => navigate({ to: tab.to }),
  }));

  return (
    <MobileShell nav={<BottomNav items={items} />}>
      <Outlet />
    </MobileShell>
  );
}
